const day = (year, month, date) => Date.UTC(year, month - 1, date);

const baseProject = (overrides) => ({
	Owned: true,
	Owner: '',
	StartDate: day(2025, 1, 1),
	EndDate: day(2027, 12, 31),
	RemainingDurationUnit: 'days',
	DisplayTime: true,
	AllowNotStartDurationChanges: false,
	AllowOffline: false,
	Kml: 'areas.kml',
	Overlay: '',
	North: null,
	South: null,
	East: null,
	West: null,
	Permissions: {},
	activityCodeTypes: {
		area: { name: 'Area' },
		zone: { name: 'Zone' }
	},
	areaProperty: 'area',
	filterOptions: {
		flags: [],
		activityStatus: ['TK_NotStart', 'TK_Active', 'TK_Complete'],
		resources: [],
		totalFloat: { min: 0, max: 40 },
		activityCodeTypeActivityCodes: {},
		activityCodesHashMap: {}
	},
	...overrides
});

export const getDevMockDatasets = () => ({
	dia: baseProject({
		Id: 'dia',
		Name: 'DIA Terminal Expansion',
		SourceFormat: 'xer'
	}),
	runway: baseProject({
		Id: 'runway',
		Name: 'Runway 16R Overlay',
		SourceFormat: 'mspdi',
		Owned: false,
		Owner: 'Alex Chen',
		StartDate: day(2025, 3, 15),
		EndDate: day(2026, 11, 30)
	}),
	cargo: baseProject({
		Id: 'cargo',
		Name: 'Cargo Apron Phase 2',
		SourceFormat: 'xer',
		StartDate: day(2025, 6, 1),
		EndDate: day(2026, 8, 31)
	})
});

export const getDevMockDatasetInfo = datasetId => ({
	success: true,
	wbsTree: {},
	activities: [],
	activitiesMap: {},
	activityCodesRelativesMap: {},
	activityCodesTree: {},
	activityCodesTreeSequence: [],
	layouts: [],
	Id: null,
	ViewType: 'WBS List',
	GroupBy: null,
	GroupByActivityCode: null,
	MapGroupBy: null,
	datasetId
});

export const shouldUseDevMockProjects = () => Boolean(import.meta.env.DEV);

export const withDevTimeout = (promise, ms = 1500) => new Promise((resolve, reject) => {
	const timer = setTimeout(() => reject(new Error('dev-mock-timeout')), ms);
	promise.then(
		value => {
			clearTimeout(timer);
			resolve(value);
		},
		error => {
			clearTimeout(timer);
			reject(error);
		}
	);
});
